export default "<!-- Ngx loader -->\n<ngx-ui-loader></ngx-ui-loader>\n\n<!-- Main view/routes wrapper-->\n<router-outlet></router-outlet>"